export interface VideoTourData {
  title: string;
  subtitle: string;
  description: string;
  posterImage: string;
  videoUrl: string; // Embeddable YouTube URL or HTML5 MP4 link
}

export const factoryTourData: VideoTourData = {
  title: 'FACTORY TOUR',
  subtitle: 'Inside Our Manufacturing Facility',
  description: 'See our manufacturing unit in action.',
  posterImage: '/aboutimages/company-tour-img.webp',
  videoUrl: '/home/about/companytour.mp4',
};